import cheetahImage from '../assets/banner.jpg'
import { CardItem, CTA, ProcessItem } from '@/components'
import SmartphoneAlarm from '../assets/animations/SmartphoneAlarm.json'
import Announcement from '../assets/animations/Announcement.json'
import { Fade, Zoom, JackInTheBox, Slide } from "react-awesome-reveal";
import BasicTrophy from '../assets/animations/BasicTrophy.json'
import NotePaper from '../assets/animations/NotePaper.json'
import SmartphoneChat from '../assets/animations/SmartphoneChat.json'
import { TypeAnimation } from 'react-type-animation'
import { windowWidth } from '@/services/services'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import { Helmet } from 'react-helmet-async';


export const Home = () => {
    return (
        <>

        <Helmet>
            <title>Morse Code Academy</title>
            <meta name="title" content="Morse Code Academy" />
            <meta
                name="description"
                content="Morse Code Academy is an Educational Application, that teaches users The Morse Code in any language they prefer, and prepares them through several practices before rewarding them with a certificate."
            />
            <meta
                property="og:description"
                content="Morse Code Academy is an Educational Application, that teaches users The Morse Code in any language they prefer, and prepares them through several practices before rewarding them with a certificate."
            />
            <meta property="og:image" content={cheetahImage} />
            <meta
                property="og:title"
                content="Morse Code Academy"
            />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://morsecodeacademy.site/" />
        </Helmet>

            <JackInTheBox triggerOnce={true} >
                <div className=" banner " style={{ backgroundImage: `url(${cheetahImage})` }}>
                    <div className="overlay black"></div>
                    <div className="container py-100 d-flex mh-100v align-items-center justify-content-center">
                        <div className="row  ">
                            <div className="col-lg-12">
                                <Fade triggerOnce={true} delay={1500}>
                                <h1 className='text-white-always d-none'>
                                        Morse Code Academy
                                    </h1>
                                    <h1 className='text-white-always'>
                                        ARE YOU READY <br />TO LEARN <br />THE <span className="stroke white">MORSE</span> CODE
                                    </h1>
                                </Fade>
                            </div>
                            <div className="col-lg-6">
                                <div className="pl-lg-5 mt-3">
                                    <Fade triggerOnce={true} delay={1800}>
                                        <p className='text-white-always '>Morse Code Academy is an Educational Application, that teaches users The Morse Code in any language they prefer, and prepares them through several practices before rewarding them with a certificate.</p>
                                    </Fade>
                                    <div className="d-flex mt-3">
                                        <Fade triggerOnce={true} delay={2000}>
                                            <a className=" theme-btn btn-outline white mr-3" href="#download">
                                                <span>Download App</span>
                                            </a>
                                            <a className="  theme-btn btn-filled pointer" href="#features">
                                                <span>App Features</span>
                                            </a>
                                        </Fade>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </JackInTheBox>
            <div className="container py-100 our-services" id="features">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <Slide delay={200} > <h1 className='text-white pb-4'> <span className="stroke">UNMATCHED</span> APP FEATURES</h1></Slide>
                    </div>
                    <div className="col-lg-4 col-md-6 pt-3 pb-2">
                        <CardItem
                            delay={1000}

                            lottie={Announcement}
                            title={"Multilingual"}
                            text={"The Morse Code Academy app effectively teaches Morse code in six languages: English, Armenian, Arabic, Spanish, French, and Russian."}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 pt-3 pb-2">
                        <CardItem
                            delay={1200}
                            icon={"fa-solid fa-rocket"}
                            lottie={NotePaper}
                            title={"Unlimited Practices"}
                            text={"Morse Code Academy offers unlimited practice opportunities, allowing users to hone their skills as much as they like across various categories, including letters, numbers, and sentences."}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 pt-3 pb-2">
                        <CardItem
                            delay={windowWidth <= 1 ? 1000 : 1400}
                            lottie={BasicTrophy}
                            title={"Certificate of Completion"}
                            text={"Morse Code Academy awards users a certificate upon successfully completing all practice sessions."}
                        />
                    </div>

                    <div className="col-lg-4 col-md-6 pt-3 pb-2">
                        <CardItem
                            delay={windowWidth <= 1 ? 1200 : 1600}
                            lottie={SmartphoneAlarm}
                            title={"Daily Challenges"}
                            text={"Morse Code Academy features Daily Challenges where users decode a message presented in Morse code, typically consisting of an inspiring quote."}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 pt-3 pb-2">
                        <CardItem
                            delay={windowWidth <= 1 ? 1000 : 1800}
                            lottie={SmartphoneChat}
                            title={"Real-Time Translations"}
                            text={"Morse Code Academy offers a feature that allows users to transmit their Morse code through flashlight signals, sound audio, or text."}
                        />
                    </div>
                </div>
            </div>

            <Zoom triggerOnce={true} delay={500}>
                <div className="bg-primary py-100 text-center px-3  hover-khosher">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <h2 style={{ opacity: 0, }} className='text-white-always'>TAP INTO THE POWER OF MORSE CODE!</h2>
                            <div className="position-absolute" style={{ top: 0 }}>
                                <Fade delay={800}>
                                    <TypeAnimation
                                        sequence={[
                                            'TAP INTO THE POWER OF MORSE CODE!',
                                            1000,
                                            ''
                                        ]}
                                        omitDeletionAnimation={true}
                                        wrapper="h2"
                                        className='text-white-always'
                                        speed={50}
                                        repeat={Infinity}
                                    />
                                </Fade>
                            </div>
                        </div>
                    </div>
                </div>
            </Zoom>

            <div className="container py-100 our-services" id="services">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <Slide delay={200} direction='left'>
                            <h1 className='text-white '>MORSE <span className="stroke">CODE</span> ACADEMY <span className="stroke">APP</span></h1>
                        </Slide>

                    </div>

                    <div className="col-lg-10">
                        <Swiper
                            spaceBetween={50}
                            slidesPerView={3}
                            slidesPerGroup={3}
                            breakpoints={{
                                // when window width is >= 320px
                                220: {
                                    slidesPerView: 1,
                                    slidesPerGroup: 1,
                                    autoplay: {
                                        delay: 1500
                                    }
                                },
                                900: {
                                    slidesPerView: 3,
                                    slidesPerGroup: 3,
                                    autoplay: {
                                        delay: 5000
                                    }
                                }
                            }}
                            autoplay={{
                                delay: 5000
                            }}
                            modules={[Navigation, Pagination, Scrollbar, Autoplay, A11y]}
                            loop={true}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >

                            {[1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]?.map((item, index) =>
                                <SwiperSlide key={index}>
                                    <img src={require(`../assets/images/mockups/${item}.png`)} className='w-100' 
                                    alt="Morse Code Academy"
                                    />
                                </SwiperSlide>)}



                        </Swiper>
                    </div>



                </div>
            </div>



            <div className="bg-primary py-100 text-center px-3 hover-khosher">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <h2 className='text-white-always mb-3'>Why Choose Morse Code Academy ? </h2>
                        <div className="position-relative">
                            <h2 style={{ opacity: 0 }}> Anticipate beyond what is guaranteed.</h2>
                            <div className="position-absolute center w-100" style={{ top: 0 }}>
                                <TypeAnimation
                                    sequence={[
                                        "We introduce the user about morse code and it's history",
                                        700,
                                        "We educate the user by teaching them the basics",
                                        700,
                                        "We provide unlimited practices",
                                        700,
                                        "Real-time transliteration in multiple languages",
                                        700,
                                        "We provide a certificate of completion",
                                        700,
                                    ]}
                                    omitDeletionAnimation={true}
                                    wrapper="h3"
                                    className='text-white-always '
                                    speed={25}
                                    repeat={Infinity}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container py-100 our-services" id="services">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <Slide delay={200} direction='left'>
                            <h1 className='text-white '>FROM DASHES TO <span className="stroke">MASTERY</span></h1>
                        </Slide>
                        <Slide direction='left' delay={400}>
                            <h1 className='text-white pb-4'><span className="stroke">MORSE CODE</span> MADE EASY!</h1>
                        </Slide>
                    </div>

                    <div className="col-xl-4 px-3 px-md-1 col-md-6 col-12 py-0 py-3">
                        <ProcessItem
                            title={"The Basics"}
                            count={"Step 01"}
                            delay={1000}
                            pos='bottom'
                            content={"Begin by familiarizing yourself with the fundamentals of Morse code by learning the alphabet"}
                        />
                    </div>
                    <div className="col-xl-4 px-3 px-md-1 col-md-6 col-12 py-0 py-3">
                        <ProcessItem
                            title={"Numbers & Operators"}
                            delay={1200}

                            count={"Step 02"}
                            content={"Master the basics of morse code by focusing on numbers and essential operators"}
                        />
                    </div>
                    <div className="col-xl-4 px-3 px-md-1 col-md-6 col-12 py-0 py-3">
                        <ProcessItem
                            title={"Training & Certification"}
                            count={"Step 03"}
                            pos='bottom'
                            delay={windowWidth <= 1 ? 1000 : 1400}
                            content={"Start your morse code training from basics letters to words then sentences and earn a certificate of completion!"}
                        />
                    </div>
                    {/* <div className="col-xl-3 px-3 px-md-1 col-md-6 col-12 py-0 py-3">
                        <ProcessItem
                            title={"Training & Maintenance "}
                            count={"Step 05"}
                            delay={windowWidth <= 1 ? 1200 : 1600}

                            content={"After project implementation, we offer training and provide ongoing support for maintenance and inquiries. We're also available to expand or modify the project as needed."}
                        />
                    </div>
                    <div className="col-xl-3 px-3 px-md-1 col-md-6 col-12 py-0 py-3">
                        <ProcessItem
                            delay={windowWidth <= 1 ? 1000 : 1800}

                            title={"Testing and Quality Assurance:"}
                            count={"Step 04"}
                            content={"We perform comprehensive testing, including unit, quality, and user acceptance tests, to ensure our solution is functional, user-friendly, secure, and reliable"}
                        />
                    </div> */}
                </div>
            </div>



            <CTA
            />
        </>
    )
}

